module.exports = __webpack_public_path__ + "static/img/people.e5ddffe6.png";